var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-button',{class:[_vm.$style.button, ( _obj = {}, _obj[_vm.$style.coupon] = _vm.type === 'coupon', _obj )],attrs:{"icon":_vm.bonusDeficit ? undefined : 'far fa-check',"fill":"","large":"","disabled":!!_vm.bonusDeficit},on:{"click":_vm.onRequestClicked}},[_vm._v(_vm._s(_vm.requestButtonText))])}
var staticRenderFns = []

export { render, staticRenderFns }